export default {
  FORMAT_DATE: 1,
  COMPARE_CURRENT_DATE: 3,
};
export const DISPLAY_FORMAT = 'L';
// export const ISO_FORMAT = 'YYYY-MM-DD';
// export const ISO_FORMAT_M = 'YYYY-M-DD';
// export const ISO_FORMAT_D = 'YYYY-MM-D';
// export const ISO_FORMAT_M_D = 'YYYY-M-D';
export const ISO_FORMAT = 'MM/DD/YYYY';
export const ISO_FORMAT_M = 'M/DD/YYYY';
export const ISO_FORMAT_D = 'MM/D/YYYY';
export const ISO_FORMAT_M_D = 'M/D/YYYY';
export const ISO_MONTH_FORMAT = 'YYYY-MM';
